// removed by extract-text-webpack-plugin
module.exports = {"Times":"src-components-DayInTheLife-Times----Times-module---Times---2bRc8","timeRight":"src-components-DayInTheLife-Times----Times-module---timeRight---1dxvz","timeLeft":"src-components-DayInTheLife-Times----Times-module---timeLeft---36T0S","Time":"src-components-DayInTheLife-Times----Times-module---Time---1RXgN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DayInTheLife/Times/Times.module.scss
// module id = 721
// module chunks = 168000803916113